import React from 'react';
import './SignInBackground.css';

// --- Layered effect subcomponents (kept small for maintainability) ---

const Pulse = () => <div className="fb-pulse" aria-hidden="true" />;

const Orbs = () => (
  <>
    <div className="fb-orb fb-orb--1" aria-hidden="true" />
    <div className="fb-orb fb-orb--2" aria-hidden="true" />
    <div className="fb-orb fb-orb--3" aria-hidden="true" />
    <div className="fb-orb fb-orb--4" aria-hidden="true" />
  </>
);

const Aurora = () => (
  <>
    <div className="fb-aurora fb-aurora--top" aria-hidden="true" />
    <div className="fb-aurora fb-aurora--bottom" aria-hidden="true" />
  </>
);

const DotGrid = () => <div className="fb-grid" aria-hidden="true" />;

const ECG_PATH = 'M -50 40 L 100 40 L 130 40 L 160 40 L 190 35 L 220 25 L 250 60 L 270 5  L 290 60 L 310 35 L 340 40 L 600 40 L 700 40 L 730 35 L 760 25 L 790 60 L 810 5 L 830 60 L 850 35 L 880 40 L 1250 40';

const ECG = () => (
  <svg className="fb-ecg" viewBox="0 0 1200 80" preserveAspectRatio="none" aria-hidden="true">
    <defs>
      <linearGradient id="fb-ecg-fade" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0" stopColor="#ef4444" stopOpacity="0" />
        <stop offset="0.15" stopColor="#ef4444" stopOpacity="0.55" />
        <stop offset="0.85" stopColor="#ef4444" stopOpacity="0.55" />
        <stop offset="1" stopColor="#ef4444" stopOpacity="0" />
      </linearGradient>
      <filter id="fb-ecg-glow" x="-20%" y="-50%" width="140%" height="200%">
        <feGaussianBlur stdDeviation="2.4" result="b" />
        <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
    </defs>
    <path d={ECG_PATH} fill="none" stroke="url(#fb-ecg-fade)" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round" filter="url(#fb-ecg-glow)" className="fb-ecg__path" />
  </svg>
);

/**
 * Animated background for the sign-in page — black base + red accents.
 * All animations are pure CSS and respect prefers-reduced-motion.
 */
const SignInBackground = ({ children }) => (
  <div className="fb-signin-bg">
    <Pulse />
    <Orbs />
    <Aurora />
    <DotGrid />
    <ECG />
    <div className="fb-spark" aria-hidden="true" />
    <div className="fb-signin-bg__content">{children}</div>
  </div>
);

export default SignInBackground;
